import { EntityDescriptor } from "@crispico/foundation-react";
import { FieldType } from "@crispico/foundation-react/entity_crud/FieldType";

export class InvoicePriceRuleEntityDescriptor extends EntityDescriptor {
    constructor() {
        super({
            name: "InvoicePriceRule",
            icon: "file text"
        });
    }

    protected customize() {
        this.addFieldDescriptor({ name: "price", type: FieldType.number });
        this.addFieldDescriptor({ name: "nightPriceDiffrence", type: FieldType.number });
        this.addFieldDescriptor({ name: "weekendPriceDiffrence", type: FieldType.number });
        this.addFieldDescriptor({ name: "weekendNightsDiffrence", type: FieldType.number });
        this.addFieldDescriptor({ name: "priceType", type: FieldType.dropdown, fieldDescriptorSettings: {
            fieldIntervals: [
                { from: "0", label: _msg("InvoicePriceRule.priceType.task") },
                { from: "1", label: _msg("InvoicePriceRule.priceType.equipment") },
                { from: "2", label: _msg("InvoicePriceRule.priceType.flight") }]
            } 
        });
        this.isInDefaultColumnConfig(true, "objectType", "priceType", "price", "nightPriceDiffrence", "weekendPriceDiffrence", "weekendNightsDiffrence", "invoiceRule");
    }
}